import { DisplayObject, FederatedPointerEvent } from 'pixi.js'

export function onPointerTap(
  target: DisplayObject,
  handler: (e: FederatedPointerEvent) => void,
  context?: unknown,
): void {
  target.on('pointertap', (e: FederatedPointerEvent) => {
    // Only left mouse button (0) or touch (no button property)
    if (e.data.button === 0 || e.data.pointerType === 'touch') {
      handler.call(context ?? target, e)
    }
  })
}
